var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"elevation-3",attrs:{"color":_vm.outerColor,"size":_vm.size,"dark":""}},[_c('v-avatar',{attrs:{"color":_vm.color,"size":_vm.innerSize,"dark":""}},[_c('span',{staticClass:"font-weight-bold",class:_vm.textColor + '--text',style:('letter-spacing:0px;font-size:' + _vm.fontSize + 'px')},[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }